import type { ReactNode } from 'react';

interface RequireSettingsAccessProps {
  children: ReactNode;
}

/** All authenticated users may access Settings (About, legal links). */
export function RequireSettingsAccess({ children }: RequireSettingsAccessProps) {
  return <>{children}</>;
}
